(function ($) {
    'use strict';

    function selectWpformsModernByValue(fieldSelector, value) {
        const $select = $(fieldSelector);

        if (!$select.length) return;

        // Set value on the real select
        $select.val(value).trigger('change');

        // If WPForms modern select has an attached instance (Select2-like),
        // trigger the UI update too
        const selectEl = $select.get(0);

        // WPForms modern uses a select wrapper; forcing change usually updates UI
        // but we can be extra safe and trigger 'input'
        $(selectEl).trigger('input').trigger('wpformsFieldChange');
    }

    window.selectWpformsModernByValue = selectWpformsModernByValue;

    // Get URL params if exists
    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        const results = regex.exec(location.search);
        return results === null
            ? ''
            : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    const params = new URLSearchParams(window.location.search);

    var helpField = $('.wpforms-field-help').find('select');
    var packageField = $('.wpforms-field-package').find('select');

    // If URL has param 'package', select an option for booking a content package from the form

    if (params.has('package')) {
        // Convert param value to capitalise first letter
        var packageValue =
            params.get('package').charAt(0).toUpperCase() +
            params.get('package').slice(1);

        // Choose option for booking
        selectWpformsModernByValue(helpField, 'Book a content package');
        // Find WPForms dropdown element and update based on param value
        selectWpformsModernByValue(packageField, packageValue);

        console.log(packageValue);
    }
})(jQuery);
